import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import { Context } from "types/generated";

import { GET_CONTEXTS } from "./gql";

const EMPTY_CONTEXTS: Context[] = [];

const useSpaceContexts = (space: string) => {
  const { data, loading, networkStatus, refetch, error } = useQuery<{
    attachableContextsInSpace: Context[];
  }>(GET_CONTEXTS, {
    variables: { id: space },
  });

  const isLoading = loading && networkStatus !== NetworkStatus.refetch;
  const isRefetching = loading && networkStatus === NetworkStatus.refetch;

  return {
    spaceContexts: data?.attachableContextsInSpace || EMPTY_CONTEXTS,
    loading: isLoading,
    refetching: isRefetching,
    hasData: !isLoading && !!data?.attachableContextsInSpace,
    refetch,
    error,
  };
};

export default useSpaceContexts;
